import { IPaginationResourceShort } from '../../../props/general';
import { IVesselRequisitionItemResourceShortProps } from '../../../props/vessels/requisitions/item';
import Request from '../../request';

const VesselRequisitionItemService = {
  retrieve: async (requisitionId: string, qs?: string): Promise<{ data: IVesselRequisitionItemResourceShortProps[], pagination: IPaginationResourceShort }> => {
    try {
      const results = await Request.get(`/api/vessels/requisitions/${requisitionId}/items?${qs || ''}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  approve: async (requisitionId: string, data: FormData): Promise<{}> => {
    try {
      const result = await Request.post(`/api/vessels/requisitions/${requisitionId}/items/approve`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  reject: async (requisitionId: string, data: FormData): Promise<{}> => {
    try {
      const result = await Request.post(`/api/vessels/requisitions/${requisitionId}/items/reject`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  }
};

export default VesselRequisitionItemService;
